<template>
    <b-list-group v-if="translations">
        <b-list-group-item
                class="flex-column align-items-start"
                v-for="translation in translations"
                :key="`${translation.locale}${translation.id}`"
        >
            <div class="d-flex w-100 justify-content-between">
                <small>{{translation.locale}}</small>
            </div>

            <template v-if="translation.title">
                <p class="mb-1">
                    {{translation.title}}
                </p>
            </template>

            <template v-if="translation.description">
                <p class="mb-1">
                    {{translation.description}}
                </p>
            </template>

        </b-list-group-item>
    </b-list-group>
</template>

<script>
    export default {
        name: 'TableSlotTranslations',
        props: {
            translations: {
                required: true,
                type: Object | Array,
            },
        },
    }
</script>